import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/storage'

// Modules
import auth from './auth'
import units from './units'
import companies from './companies'
import resource from './resource'

import roles from './roles'

// Globals
import getters from './getters'
import state from './state'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
    state: state,
    getters: getters,
    mutations: {
        setLocale: (state, locale) => {
            state.locale = locale
        },
    },
    actions: {
        changeLocaleTo: ({ commit }, locale) => {
            // console.log('Setting locale to ', locale)
            storage.set('locale', locale)
            commit('setLocale', locale)
        },
    },
    modules: {
        auth: auth,
        units: units,
        companies: companies,
        resource: resource,
        roles: roles,
    },
    strict: debug,
})

export default store
